(() => {
  'use strict';
  let cleanup = () => {};

  function boot() {
    cleanup();
    const controller = new AbortController();
    const { signal } = controller;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const observers = [];
    let frame = 0;
    let sceneVisible = true;
    const scene = document.querySelector('[data-sh-scene]');
    const story = document.querySelector('[data-sh-story]');
    const menu = document.querySelector('.sh-pocket-menu');
    const on = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });

    on(document, 'click', event => {
      if (menu?.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
    });
    on(document, 'keydown', event => {
      if (event.key === 'Escape' && menu?.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });

    if (story && !story.querySelector('.sh-story-word')) {
      const words = story.textContent.trim().split(/\s+/);
      story.replaceChildren();
      words.forEach((word, index) => {
        const span = document.createElement('span');
        span.className = 'sh-story-word';
        span.textContent = word;
        story.append(span);
        if (index < words.length - 1) story.append(' ');
      });
    }
    const words = story ? [...story.querySelectorAll('.sh-story-word')] : [];
    function updateStory() {
      frame = 0;
      if (scene && sceneVisible && !reduced.matches && finePointer.matches) {
        const scroll = Math.max(0, Math.min(45, -scene.getBoundingClientRect().top * .1));
        scene.style.setProperty('--sh-scroll-y', scroll + 'px');
      }
      if (!story) return;
      const rect = story.getBoundingClientRect();
      const viewport = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewport) return;
      words.forEach(word => {
        const y = word.getBoundingClientRect().top;
        word.style.opacity = reduced.matches || y < viewport * .78 ? '1' : '.67';
      });
    }
    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(updateStory);
    }
    on(window, 'scroll', requestUpdate, { passive: true });
    on(window, 'resize', requestUpdate, { passive: true });
    on(reduced, 'change', requestUpdate);
    updateStory();

    if ('IntersectionObserver' in window) {
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sh-visible');
          entry.target.classList.remove('sh-awaiting');
          reveal.unobserve(entry.target);
        });
      }, { threshold: .08 });
      document.querySelectorAll('[data-sh-reveal]').forEach(node => {
        if (node.getBoundingClientRect().top > window.innerHeight && !reduced.matches) node.classList.add('sh-awaiting');
        reveal.observe(node);
      });
      observers.push(reveal);
      if (scene) {
        const sceneObserver = new IntersectionObserver(entries => {
          sceneVisible = entries[0].isIntersecting;
        });
        sceneObserver.observe(scene);
        observers.push(sceneObserver);
      }
      const links = [...document.querySelectorAll('.sh-wide-nav a[href*="#"]')];
      const sectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          links.forEach(link => {
            if (new URL(link.href).hash === '#' + entry.target.id) link.setAttribute('aria-current','location');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-15% 0px -60% 0px' });
      links.forEach(link => {
        const target = document.querySelector(new URL(link.href).hash);
        if (target) sectionObserver.observe(target);
      });
      observers.push(sectionObserver);
    }
    document.body.classList.add('sh-entered');

    on(scene, 'pointermove', event => {
      if (!finePointer.matches || reduced.matches || !sceneVisible) return;
      const rect = scene.getBoundingClientRect();
      scene.style.setProperty('--sh-scene-x', ((event.clientX - rect.left) / rect.width - .5) * 15 + 'px');
      scene.style.setProperty('--sh-scene-y', ((event.clientY - rect.top) / rect.height - .5) * 12 + 'px');
    });
    on(scene, 'pointerleave', () => {
      scene.style.setProperty('--sh-scene-x','0px');
      scene.style.setProperty('--sh-scene-y','0px');
    });
    document.querySelectorAll('[data-sh-tilt]').forEach(node => {
      on(node, 'pointermove', event => {
        if (!finePointer.matches || reduced.matches) return;
        const rect = node.getBoundingClientRect();
        node.style.setProperty('--sh-tilt-x', -((event.clientY - rect.top) / rect.height - .5) * 5 + 'deg');
        node.style.setProperty('--sh-tilt-y', ((event.clientX - rect.left) / rect.width - .5) * 7 + 'deg');
      });
      on(node, 'pointerleave', () => {
        node.style.setProperty('--sh-tilt-x','0deg');
        node.style.setProperty('--sh-tilt-y','0deg');
      });
    });
    const card = document.querySelector('.sh-message-card');
    const pull = document.getElementById('sh-pull-message');
    on(pull, 'click', () => {
      if (!card || reduced.matches) return;
      card.classList.remove('sh-drawing');
      requestAnimationFrame(() => card.classList.add('sh-drawing'));
    });
    on(card, 'animationend', () => card.classList.remove('sh-drawing'));
    let pointerStart = null;
    on(card, 'pointerdown', event => { pointerStart = { x: event.clientX, y: event.clientY }; });
    on(card, 'pointercancel', () => { pointerStart = null; });
    on(card, 'pointerup', event => {
      if (!pointerStart) return;
      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) pull?.click();
    });
    document.querySelectorAll('[data-sh-gallery]').forEach(button => {
      on(button, 'click', () => {
        const gallery = document.querySelector('.sh-scarf-peek');
        if (!gallery) return;
        gallery.scrollBy({ left: gallery.clientWidth * .85 * Number(button.dataset.shGallery), behavior: reduced.matches ? 'instant' : 'smooth' });
      });
    });
    cleanup = () => {
      controller.abort();
      observers.forEach(observer => observer.disconnect());
      cancelAnimationFrame(frame);
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{ once:true });
  else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',boot);
})();
